import {Outlet} from '@github-ui/react-router'

import {GlobalNavBar} from '@github-ui/global-navigation/bar'

const globalNavBarArgs = {
  navMenu: {
    home: {
      show: true,
    },
    issues: {
      show: true,
    },
    pulls: {
      show: true,
    },
    contributedRepos: {
      show: true,
    },
    projects: {
      show: true,
    },
    discussions: {
      show: true,
    },
    codespaces: {
      show: true,
    },
    copilot: {
      show: true,
    },
    spark: {
      show: true,
    },
    marketplace: {
      show: true,
    },
    explore: {
      show: true,
    },

    richContent: {
      enabled: true,
      contentUrl: '/_side_bar_content',
      repositoriesSearchUrl: '/_side-panel-items/global/repositories',
      teamsSearchUrl: '/_side-panel-items/global/teams',
    },
  },
  userMenu: {
    owner: {
      login: 'monalisa',
      name: 'Monalisa Octocat',
      avatarUrl: 'https://avatars.githubusercontent.com/u/92997159?v=4',
    },
    lazyLoadItemDataFetchUrl: '_side-panels/user.json',
    addAccountPath: '/add_account_path',
    switchAccountPath: '/switch_account_path',
    loginAccountPath: '/login?add_account=1',
    showAccountSwitcher: true,
    showCopilot: true,
    canAddAccount: true,
    showEnterprises: true,
    showEnterprise: true,
    showOrganizations: true,
    showGists: true,
    showSponsors: true,
    showUpgrade: true,
    showFeaturesPreviews: true,
    showEnterpriseSettings: true,
    showGithubMCPServerCTA: false,
    projectsPath: '/projects',
    gistsUrl: 'https://gist.github.com/mine',
    docsUrl: 'https://docs.github.com/',
    yourEnterpriseUrl: 'https://github.com/enterprises/github-inc',
    enterpriseSettingsUrl: 'https://github.com/enterprise/settings',
    supportUrl: 'https://support.github.com/',
    createMenuProps: {},
    onClose: () => {},
  },
  headerLogo: {
    hotkey: 'g d',
  },
}

export function AppShellLayout() {
  // Once we wire data to the global nav bar:
  // const payload = useRouteQuery(appShellLayoutRoute, 'mainQuery')

  return (
    <div>
      <GlobalNavBar {...globalNavBarArgs} />
      <Outlet />
    </div>
  )
}

try{ AppShellLayout.displayName ||= 'AppShellLayout' } catch {}